module.exports = __webpack_public_path__ + "media/images/emblems/Pontresina_wappen-db7b8149fa1be06c9fa27c760c1fd3bd.svg";